export class InternalServerError extends Error {
  constructor() {
    super('Um erro em nosso servidor foi detectado. Tente novamente em breve.');
    this.name = 'InternalServerError';
  }
}
